import * as React from "react"; 
import "./OwnerCtl.scss";
import { Territory } from "@testout/testout-commerce/models/commerce/Territory";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import { Email } from "@testout/testout-commerce/models/Email";

interface IOwnerProps {
    disabled?: boolean;
    employees: ListItem[]
    territory?: Territory;
    value?: string;
    onChange?: (salespersonCode: string) => void;
    className?: string;
    ownerRoles?: string[];
}

export enum OwnerRoles {
    AE = "ae",
    CSM = "csm",
    MCS = "mcs"
}

export default class OwnerCtl extends React.PureComponent<IOwnerProps> {

    private defaultOwnerRoles = [ OwnerRoles.AE, OwnerRoles.CSM, OwnerRoles.MCS ];

    private getEmployeeName(employeeNumber: string | undefined) {
        const employee = this.props.employees?.find(e => e.value === employeeNumber);
        return !employee ? employeeNumber : employee.name;
    }

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.onChange?.(e.target.value);
    }

    render() {
        let { value, ownerRoles, territory, disabled } = this.props;
        if (!ownerRoles) ownerRoles = this.defaultOwnerRoles;

        let employees: { [code: string]: string[] } = {};
        if (territory)
            for (const role of Object.keys(territory.roles))
                if (employees[territory.roles[role]])
                    employees[territory.roles[role]].push(role); 
                else
                    employees[territory.roles[role]] = [role];

        // Ensure the owner is shown even if there is no territory or the owner has no territory role
        if (value)
            if (employees[value])
                employees[value].push("");
            else
                employees[value] = [""];

        return <div className={"owner" + (this.props.className ? " " + this.props.className : "")}>
                   <span className="name">{territory ? territory.territoryName : `Unknown territory (segment, state, and country needed)${!value ? " and owner" : ""}`}</span>
                   {Object.keys(employees).map(code =>
                <label key={code} className={`role${employees[code].find(r => ownerRoles?.includes(r)) ? " owner" : ""}${code === value ? " selected" : ""}${disabled ? " disabled" : ""}`}>
                    {employees[code].find(r => ownerRoles?.includes(r)) && <input name="owner" type="radio" title="Role" disabled={disabled}
                        value={code}
                        checked={code === value}
                        onChange={this.onChange} />}
                    <span>{employees[code].join("/")}
                        {code === value && <span className="selected">Owner</span>}
                    </span>
                    <span>{this.getEmployeeName(code)}</span>
                </label>)}
               </div>;
    }
}